import { ColumnsType, InfiniteTable } from '@/components/_common';
import EyeIcon from '@/components/_common/EyeIcon';
import { useWorkOrderAuditComplementItems } from '@/core/domain/workorder/AuditData/AuditData.hooks';
import {
  WorkOrderAuditDataComplementItemsRequest,
  WorkOrderAuditDataComplementItemsResponse,
} from '@/core/domain/workorder/AuditData/AuditData.types';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Card } from 'antd';

interface Props {
  queryParams?: WorkOrderAuditDataComplementItemsRequest;
}

export default function AuditComplementItemsTable({ queryParams }: Props) {
  const workOrderAuditComplementItems = useWorkOrderAuditComplementItems({
    ...queryParams,
  });
  const workOrderAuditComplementItemsData = flatInfiniteData(
    workOrderAuditComplementItems.data,
  );

  const columns: ColumnsType<WorkOrderAuditDataComplementItemsResponse> = [
    {
      title: 'Orçamento',
      dataIndex: 'complementNumber',
      key: 'complementNumber',
    },
    {
      title: 'Cód. Interno',
      dataIndex: 'internalCode',
      key: 'internalCode',
      render: (value) => value || '-',
    },
    {
      title: 'Cód. fabricante',
      dataIndex: 'manufacturingCode',
      key: 'manufacturingCode',
      render: (value) => value || '-',
    },
    {
      title: 'Descrição',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Visualizar',
      key: 'visualizar',
      align: 'center',
      width: 100,
      render: (_, row) => (
        <EyeIcon
          redirect={`/app/movements/workOrders/${row?.workOrderId}/complements/${row?.complementId}/generalInfo`}
          target="_blank"
          disabled={!row?.complementId || !row?.workOrderId}
        />
      ),
    },
  ];

  return (
    <Card type="inner" style={{ borderRadius: 10 }}>
      <InfiniteTable
        columns={columns}
        dataSource={workOrderAuditComplementItemsData}
        loading={workOrderAuditComplementItems.isFetching}
        scroll={{ x: true }}
        fetchNextPage={workOrderAuditComplementItems.fetchNextPage}
        hasNextPage={workOrderAuditComplementItems.hasNextPage}
      />
    </Card>
  );
}
